import styled from 'styled-components'
import Button from './Button'

const SetWidthButton = styled(Button)`
  overflow: hidden;
  text-overflow: ellipsis;
`

export default SetWidthButton
